import { render } from "./page-list.vue?vue&type=template&id=18a9e57a"
import script from "./page-list.vue?vue&type=script&lang=js"
export * from "./page-list.vue?vue&type=script&lang=js"
script.render = render

export default script